/* ============================================================
   RUGGI — Menü öğesi: harf harf renk + YENİ rozeti
   ------------------------------------------------------------
   KURULUM
   1) Online Store > Themes > ... > Edit code
   2) Assets > Add a new asset > "Create a blank file" > kids-menu.js
      Bu dosyanın içeriğini oraya yapıştır, kaydet.
   3) layout/theme.liquid icinde </body> satirinin HEMEN USTUNE
      SADECE tek satirlik script etiketini ekle (tam hali sohbette):
         src = {{ 'kids-menu.js' | asset_url }}   +   defer

   NOT: Bu dosyanin icine script etiketi YAZMA. Sadece JS olacak.
   ============================================================ */

(function () {
  /* ================= AYARLAR ================= */

  // Harf sırasına göre renkler (döngüsel kullanılır)
  var COLORS = ['#F94328', '#F2A03C', '#00966F', '#2D7DD2', '#E8368F', '#7A5CF0'];

  // 1) HANGİ LİNKLER — linkin URL'inde geçen parça(lar)
  var MATCH = ['cocuk'];

  // 2) METNE GÖRE DARALT (opsiyonel)
  //    Menüdeki öğelerin hepsi aynı koleksiyona gidiyorsa URL ile
  //    ayıramazsın; burada menü etiketiyle seçersin.
  //    []                              -> URL eşleşen tüm linkler boyanır
  //    ['KIDS']                        -> sadece "KIDS" etiketli öğe boyanır
  //    ['KIDS','ÇOCUK ODASI HALILARI'] -> ikisi birden
  var ONLY_TEXT = [];

  // 3) Rozet metni. İstemiyorsan: ''
  var BADGE = 'YENİ';

  // 4) Rozet SADECE bu etiketlerde çıksın ([] -> boyanan hepsinde çıkar)
  var BADGE_TEXT = ['KIDS'];

  // Sadece menü içindeki linkler boyansın (ürün kartı / footer hariç)
  var SCOPE = 'header, .header, nav, .menu-drawer, .mobile-nav, .drawer, .site-header';

  /* ================= 1) CSS ================= */
  var css = [
    'a[data-kids]{',
    '  position:relative !important; overflow:visible !important;',
    '  text-decoration:none !important; font-weight:800 !important;',
    '  white-space:nowrap !important; background-image:none !important;',
    '  -webkit-text-fill-color:currentColor !important;',
    '}',

    /* inline-block ŞART: inline-flex olursa kelimeler arası boşluk yutulur */
    'a[data-kids] .kids-w{',
    '  display:inline-block !important;',
    '  white-space:nowrap !important; background:none !important;',
    '  -webkit-text-fill-color:currentColor !important;',
    '}',

    'a[data-kids] i.kids-l{',
    '  font-style:normal !important; background:none !important;',
    '  -webkit-text-fill-color:currentColor !important;',
    '  display:inline-block; transition:transform .18s ease;',
    '}',
    'a[data-kids]:hover i.kids-l:nth-child(odd){ transform:translateY(-2px); }',
    'a[data-kids]:hover i.kids-l:nth-child(even){ transform:translateY(2px); }',
    '@media (prefers-reduced-motion:reduce){',
    '  a[data-kids] i.kids-l{ transition:none; transform:none !important; }',
    '}',

    /* Rozet linkin İÇİNDE akan bir öğe — absolute değil, bu yüzden
       ne taşar ne kırpılır, mobil menüde de metnin yanında kalır */
    'a[data-kids] .kids-badge{',
    '  display:inline-block !important; position:relative !important; top:-6px !important;',
    '  margin-left:6px !important; vertical-align:baseline !important;',
    '  background:' + COLORS[0] + ' !important; background-image:none !important;',
    '  color:#fff !important; -webkit-text-fill-color:#fff !important;',
    '  font-size:8px !important; font-weight:800 !important; line-height:1 !important;',
    '  letter-spacing:.08em !important; padding:3px 5px !important; border-radius:3px !important;',
    '  white-space:nowrap !important; pointer-events:none !important;',
    '  text-transform:none !important;',
    '}'
  ].join('\n');

  var style = document.createElement('style');
  style.id = 'kids-menu-style';
  style.textContent = css;
  document.head.appendChild(style);   // en sona eklenir -> tema CSS'ini ezer

  /* ================= 2) Harfleri boya ================= */
  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  var SELECTOR = MATCH.map(function (m) {
    return 'a[href*="' + m + '"]:not([data-kids])';
  }).join(',');

  function paint() {
    if (!SELECTOR) return;

    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (a) {
      if (!a.closest || !a.closest(SCOPE)) return;

      var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 40) return;

      var up = text.toLocaleUpperCase('tr-TR');

      // Metin filtresi
      if (ONLY_TEXT.length && ONLY_TEXT.map(function (x) {
        return x.toLocaleUpperCase('tr-TR');
      }).indexOf(up) === -1) return;

      var wantBadge = !!BADGE && (
        !BADGE_TEXT.length || BADGE_TEXT.map(function (x) {
          return x.toLocaleUpperCase('tr-TR');
        }).indexOf(up) > -1
      );

      a.setAttribute('data-kids', '1');
      a.setAttribute('aria-label', wantBadge ? text + ' — ' + BADGE : text);

      var i = 0;
      var letters = text.split('').map(function (ch) {
        // Boşlukları &nbsp; olarak bas -> hiçbir düzende kaybolmaz
        if (/\s/.test(ch)) { return '<i class="kids-l">&nbsp;</i>'; }
        var c = COLORS[i % COLORS.length];
        i++;
        return '<i class="kids-l" style="color:' + c + ' !important">' + esc(ch) + '</i>';
      }).join('');

      var badge = wantBadge ? '<span class="kids-badge">' + esc(BADGE) + '</span>' : '';

      // Harfler ve rozet TEK kapsayıcıda: link flex ise ikiye ayrılıp uzaklaşmazlar
      a.innerHTML = '<span class="kids-w" aria-hidden="true">' + letters + badge + '</span>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }

  /* Mega menü / mobil menü sonradan DOM'a giriyorsa onları da yakala */
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(paint, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Konsol kontrolü: __kids() */
  window.__kids = function () {
    var list = document.querySelectorAll('a[data-kids]');
    console.log('boyanan link sayisi:', list.length);
    Array.prototype.forEach.call(list, function (a) {
      console.log(a.getAttribute('href'), '|', a.getAttribute('aria-label'));
    });
  };
})();